<template>
  <div class="NoLandScape">
    <div class="NoLandScape__title" v-html="trans('title')" />

      <div class="NoLandScape__lang" @click="$root.langSwitch()">
        {{ lang == 'fr' ? 'en' : 'fr' }}
      </div>
  </div>
</template>

<script>
import Frame from '@/components/frame/Frame'
export default {
  name: 'NoLandScape',
  components: { Frame },
  translations: {
    fr: {
      title: 'Cette expérience est optimale en mode portrait.<br>Gardez votre appareil bien droit! ',
    },
    en: {
      title: 'This experience is optimized for portrait mode.<br>Keep your phone straight and enjoy!',
    }
  },
  created() {
    dataLayer.push({
      "useCaseStep": { "Id": "UCS546 - Other - Any other page | PV", "trackType": "PV" },
      "event": "VPV",
      "page": {
        ...this.tracking.page,
        contentName: "other",
        gaStep: 'nowebcam',
        requestURI: this.tracking.page.requestURI + "nowebcam",
      },
      show: this.tracking.show
    })
  },
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.NoLandScape
  position fixed
  top 0
  left 0
  z-index 999999
  height 100%
  width 100%
  overflow hidden
  text-align center
  background white

  &__lang
    position fixed
    right 20px
    top 27px
    color black
    z-index 9999999999
    font-weight 700
    text-transform uppercase
    font-size 12px

  &__title
    color black
    font-size 22px
    position relative
    margin-bottom 50px
    line-height 26px
    clear both
    top 50%
    transform translateY(-50%)
    &:after
      content ' '
      position absolute
      left 50%
      transform translateX(-50%)
      height 1px
      background black
      bottom -10px
      width 85px

</style>
